import { render, staticRenderFns } from "./ThreadsCallBack.vue?vue&type=template&id=85a3a24a&"
import script from "./ThreadsCallBack.vue?vue&type=script&lang=js&"
export * from "./ThreadsCallBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports